import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  name: 'Marcela G.',
  location: 'Buenos Aires',
  text: 'Generé mi primer plan con IA en 18 minutos. Antes me llevaba 3 horas. En un mes tripliqué los clientes que puedo atender.',
  color: 'bg-electric'
}, {
  initials: 'LP',
  name: 'Luis P.',
  location: 'Córdoba',
  text: 'Cerré mis primeras 5 ventas en la semana de lanzamiento. Los scripts de venta del Tomo 5 cambiaron todo.',
  color: 'bg-energy'
}, {
  initials: 'RM',
  name: 'Romina M.',
  location: 'Rosario',
  text: 'Pasé de $80.000 a $340.000 por mes en 6 semanas. El sistema funciona. Solo hay que ejecutarlo.',
  color: 'bg-gold'
}];
export function Testimonials() {
  return <section className="pt-6 pb-12 border-b border-petroleum bg-graphite/50" data-id="element-526">
      <div className="container mx-auto px-4" data-id="element-527">
        {/* Social Proof Header */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mb-10 flex justify-center" data-id="element-528">
          <div className="inline-flex items-center gap-4 md:gap-6 bg-petroleum/80 backdrop-blur-sm border border-electric/20 rounded-full pl-3 pr-5 md:pl-4 md:pr-7 py-2.5 md:py-3 shadow-lg shadow-electric/5" data-id="element-529">
            {/* Avatars */}
            <div className="flex -space-x-2.5" data-id="element-530">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-gradient-to-br from-electric/30 to-petroleum border-2 border-petroleum flex items-center justify-center text-[11px] md:text-xs font-bold text-white" data-id="element-531">
                  {String.fromCharCode(64 + i)}
                </div>)}
            </div>

            {/* Divider */}
            <span className="w-px h-8 md:h-9 bg-gradient-to-b from-transparent via-electric/30 to-transparent" data-id="element-532"></span>

            {/* Rating */}
            <div className="flex flex-col items-start leading-tight" data-id="element-533">
              <div className="flex items-center gap-1.5" data-id="element-534">
                <div className="flex gap-0.5 text-gold" data-id="element-535">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-gold" data-id="element-536" />)}
                </div>
                <span className="text-white font-bold text-sm md:text-base" data-id="element-537">
                  4.9
                </span>
                <span className="text-textsecondary text-xs md:text-sm" data-id="element-538">
                  /5
                </span>
              </div>
              <span className="text-[10px] md:text-xs text-textsecondary mt-0.5" data-id="element-539">
                <span className="text-electric font-semibold" data-id="element-540">+500</span>{' '}
                profesionales confían
              </span>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-541">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-petroleum border border-electric/10 rounded-xl p-6 hover:border-electric/30 transition-colors" data-id="element-542">
              <div className="flex items-center gap-4 mb-4" data-id="element-543">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-graphite font-bold text-lg`} data-id="element-544">
                  {t.initials}
                </div>
                <div data-id="element-545">
                  <div className="flex gap-1 mb-1" data-id="element-546">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-547" />)}
                  </div>
                  <div className="text-sm text-textsecondary" data-id="element-548">
                    <span className="text-white font-medium" data-id="element-549">{t.name}</span> •{' '}
                    {t.location}
                  </div>
                </div>
              </div>
              <p className="text-textsecondary italic" data-id="element-550">"{t.text}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}